export default "__VITE_ASSET__D1W1enSE__"